module.exports = __webpack_public_path__ + "f782b99b4f549d9cf47da150d2ee0059.png";